import React, { useState, useRef, useMemo } from 'react'
import EnhancedLeadsTable, { EnhancedLeadsTableRef } from '@/components/LeadsTable/EnhancedLeadsTable'
import LeadDetailsSidebar from '@/components/LeadDetails/LeadDetailsSidebar'
import { Lead } from '@/types/leads/Table'
import { useUsers } from '@/contexts/UsersContext'
import { RefreshCw } from 'lucide-react'

interface UserOption {
  value: string;
  label: string;
  email?: string;
  role?: string;
}

const ReOrderLeads: React.FC = () => {
  const { activeUsers, reorderTeamUsers } = useUsers();
  const [isLeadModalOpen, setIsLeadModalOpen] = useState(false)
  const [selectedLead, setSelectedLead] = useState<Lead | null>(null)

  const leadsTableRef = useRef<EnhancedLeadsTableRef>(null)

  const activeUsersForDropdown: UserOption[] = useMemo(() => {
    return activeUsers.map((u) => ({
      value: u.uuid,
      label: u.userName,
      email: u.userEmail,
      role: u.role?.role_name
    }));
  }, [activeUsers]);

  const handleLeadClick = (lead: Lead) => {
    setSelectedLead(lead)
    setIsLeadModalOpen(true)
  }

  const closeLeadModal = () => {
    setIsLeadModalOpen(false)
    setSelectedLead(null)
  }

  const handleLeadUpdate = async () => {
    console.log('🔄 Lead updated, refreshing table...')
    await leadsTableRef.current?.refreshLeads()
  }

  return (
    <div className="h-full flex flex-col">
      <div className="flex-1 overflow-hidden">
        <EnhancedLeadsTable
          ref={leadsTableRef}
          onLeadClick={handleLeadClick}
          excludeAgentCreated={true}
          pageTitle="Re-Order Leads"
          pageIcon={<RefreshCw className="w-6 h-6" />}
          apiEndpoint="/shopify/reorder-leads"
          showColumnSettings={false}
          ownerFilterUsers={reorderTeamUsers}
          maxDaysFuture={7}
        />
      </div>

      <LeadDetailsSidebar
        isOpen={isLeadModalOpen}
        onClose={closeLeadModal}
        lead={selectedLead}
        activeUsersForDropdown={activeUsersForDropdown}
        onUpdate={handleLeadUpdate}
      />
    </div>
  )
}

export default ReOrderLeads
